// src/components/js/TrustpilotWidget.js
import React, { useEffect } from 'react';

const TrustpilotWidget = () => {
    useEffect(() => {
        // Dynamically add the TrustBox script only once when the component mounts
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        document.body.appendChild(script);
    }, []);

    return (
        <div className="trustpilot-container">
            {/* TrustBox widget - Mini */}
            <div
                className="trustpilot-widget"
                data-locale="en-US"
                data-template-id="53aa8807dec7e10d38f59f32"
                data-businessunit-id="66fd61c6c8cf3c57b7a89b72"
                data-style-height="150px"
                data-style-width="100%"
            >
                <a
                    href="https://www.trustpilot.com/review/affordablecustomehr.com"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Trustpilot
                </a>
            </div>
        </div>
    );
};

export default TrustpilotWidget;
